const range = (from, to) => new Array(Math.abs(to - from) + 1).fill(null).map((_row, idx) => from + idx);

export default range;
